import { render, staticRenderFns } from "./DropdownCounter.vue?vue&type=template&id=fa0e7810&scoped=true"
import script from "./DropdownCounter.vue?vue&type=script&lang=js"
export * from "./DropdownCounter.vue?vue&type=script&lang=js"
import style0 from "./DropdownCounter.vue?vue&type=style&index=0&id=fa0e7810&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0e7810",
  null
  
)

export default component.exports